export const USERS_QUERY_KEY = ["users"];
export const PENDING_USERS_QUERY_KEY = ["pendingUsers"];
export const ROLES_QUERY_KEY = ["roles"];
export const USER_PROFILE_QUERY_KEY = ["auth", "profile"];
export const ADMIN_USER_STATS_QUERY_KEY = ["user_stats"];

export const BLOCKS_USER_QUERY_KEYS = {
  usersBase: ["blocksUsers"],
  users: (
    page: number,
    search: string,
    startDate?: string,
    endDate?: string,
  ) => ["blocksUsers", page, search, startDate, endDate],
  allUsers: (search?: string, startDate?: string, endDate?: string) => [
    "blocksUsers",
    "all",
    search,
    startDate,
    endDate,
  ],
  userById: (userId: string) => ["blocksUser", userId],
  /**
   * The batched avatar read is a *different* fetcher against a *different* route
   * (the user list, via `fetchBlocksUsersByIds`) than `userById` (the by-id
   * route). Sharing one key let the leaner list record overwrite the full one, so
   * a profile picture that had just been saved disappeared from every avatar and
   * from the nav bar once the cache went stale.
   */
  avatarById: (userId: string) => ["blocksUserAvatar", userId],
  usersByIds: (userIds: readonly string[]) => [
    "blocksUsers",
    "byIds",
    [...userIds].sort().join(","),
  ],
} as const;

export const USER_PROFILE_QUERY_KEYS = {
  base: ["userProfiles"],
  byUserId: (userId: string) => ["userProfiles", userId],
  archivedEventIds: (userId: string) => [
    "userProfiles",
    userId,
    "archivedEventIds",
  ],
  preferredOrgByUserId: (userId: string) => [
    "userProfiles",
    "preferredOrg",
    userId,
  ],
} as const;
